import styled, { css } from 'styled-components';
import { Radio } from 'antd';
import color from '../../configs/color';

const Item = styled(Radio)`
  .ant-radio-group.ant-radio-group-outline {
    width: 100%;
  }
  width: 100%;
  padding: ${(props) => {
    return props.radioPadding ? props.radioPadding : '20px 18px';
  }};
  color: ${color.black2};
  font-weight: 600;
  display: inline-flex;
  gap: 12px;
  cursor: pointer;
  border-radius: 12px;
  border: 1px solid ${color.grey1};

  .anticon {
    /* margin-right: 8px; */
  }

  &.ant-radio-wrapper-checked {
    border: 1px solid ${color.orange1};
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: ${color.orange1};
  }

  .ant-radio-inner::after {
    background-color: ${color.orange1};
  }

  ${(props) => {
    return (
      props.ghost &&
      css`
        border: none !important;
      `
    );
  }}

  span {
    padding: 0;
  }

  ::after {
    display: none;
  }
`;

const Group = styled(Radio.Group)`
  width: 100%;
  display: grid;
  grid-template-columns: ${(props) => {
    return props.rows ? `repeat(${props.rows}, 1fr)` : 'repeat(2, 1fr)';
  }};
  grid-gap: 10px;
  .ant-form label {
    font-size: 16px;
  }
`;

export default { Item, Group };
